(function (window, document, $) {
    'use strict';

    $(function() {
        $('.collapsing-list').each(async function () {
            var entryCount = $(this).data('entries');
            $(this).children().slice(entryCount).hide();
        });

        $('[data-action=collapse-list]').on('click', function () {
            var list = $($(this).data('target')),
                entryCount = list.data('entries');

            if (entryCount <= list.children.length) {
                console.log('not enough entries.');
                return;
            }

            if (list.attr('aria-expanded') === 'true') {
                list.children().slice(entryCount).hide();
                list.attr('aria-expanded', 'false');
            } else {
                list.children().slice(entryCount).show();
                $(this).hide();
                list.attr('aria-expanded', 'true');
            }
        });
    });
}(window, document, jQuery));